module.exports = __webpack_public_path__ + "assets/img/busy_1.04788b6d.png";